import { axiosInstance } from 'src/util/axios/instance.axios'
import { SkillGapInsightsResponse, SkillGapPerformance, UnusedSkillGapMetrics, UsedSkillGapMetrics, UsedSkillsOverview } from '../model/my-team-skill-gaps'

export async function getAllUsedSkills(skip: number, take: number, searchText: string, sortBy: 'asc' | 'multi'): Promise<UsedSkillsOverview> {
  const { data } = await axiosInstance.request<UsedSkillsOverview>({
    url: `/my-team/all-used-skills/?skip=${skip}&take=${take}&search=${searchText}&sort=${sortBy}`,
    method: 'POST',
  })

  return data
}

export async function getUsedSkillGaps(setIds: string[]): Promise<UsedSkillGapMetrics> {
  const { data } = await axiosInstance.request<UsedSkillGapMetrics>({
    url: `/my-team/used-skill-gap/`,
    method: 'POST',
    data: { setIds },
  })

  return data
}

export async function getAllUnusedSkills(skip: number, take: number, searchText: string): Promise<UsedSkillsOverview> {
  const { data } = await axiosInstance.request<UsedSkillsOverview>({
    url: `/my-team/all-unused-skills/?skip=${skip}&take=${take}&search=${searchText}`,
  })

  return data
}

export async function getUnusedSkillGaps(setIds: string[]): Promise<UnusedSkillGapMetrics> {
  const { data } = await axiosInstance.request<UnusedSkillGapMetrics>({
    url: `/my-team/unused-skill-gap/`,
    method: 'POST',
    data: { setIds },
  })

  return data
}

export async function getSkillGapPerformance(criticalGapThreshold: number): Promise<SkillGapPerformance> {
  const { data } = await axiosInstance.request<SkillGapPerformance>({
    url: '/my-team/skill-gap-performance/',
    data: { criticalGapThreshold },
    method: 'POST',
  })

  return data
}

export async function getSkillGapInsights(skillIds: string[], minRating: number | null, maxRating: number | null): Promise<SkillGapInsightsResponse> {
  const { data } = await axiosInstance.request<SkillGapInsightsResponse>({
    url: '/my-team/skill-gap-insights/',
    method: 'POST',
    data: {
      skillIds,
      minRating,
      maxRating,
    },
  })

  return data
}
